module.exports = __webpack_public_path__ + "img/NewLogo.90ba001c.png";